import React, { useCallback } from 'react'
import pt from 'prop-types'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Plus, Search } from 'lucide-react'
import { cn } from '@/lib/utils'
import debounce from 'lodash/debounce'
import { useTranslation } from 'react-i18next'

const ActionBar = ({
  showSearch,
  onSearchChange,
  actionButton,
  actionButtonRight,
  onNew,
  onDelete,
  newButtonText,
  className,
}) => {
  const { t } = useTranslation()
  const onChangeDebounced = useCallback(debounce(onSearchChange, 200), [onSearchChange])

  return (
    <div className={cn('flex items-center gap-2 mb-4', className)}>
      {newButtonText && (
        <Button onClick={onNew} size="sm">
          <Plus />
          {newButtonText}
        </Button>
      )}
      {actionButton}
      {actionButtonRight}
      {showSearch && (
        <div className="relative ml-auto max-w-sm">
          <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder={t('ActionBar_search_placeholder', 'Search ...')}
            onChange={(e) => onChangeDebounced(e.target.value)}
            className="pl-8 h-9"
          />
        </div>
      )}
    </div>
  )
}

ActionBar.propTypes = {
  onSearchChange: pt.func,
  onNew: pt.func,
  onDelete: pt.func,
  newButtonText: pt.string,
  showSearch: pt.bool,
}

ActionBar.defaultProps = {
  showSearch: true,
}

export default ActionBar
